<ng-container *transloco="let t; prefix: 'loan-eligibility-wizard'">
  <ng-container *ngIf="!showResultPage">
    <div class="container flex-1 max-[525px]:px-4">
      <div class="my-10">
        <progress-stepper [StepNo]="this.stepKeys.indexOf(this.activeStep) + 1" [Steps]="stepValues"></progress-stepper>
      </div>
      <ng-container [formGroup]="loanForm">
        @switch (activeStep) {
        @case ('loan') {
        <ng-container [formGroupName]="'loan'">
          <div class="mb-10 text-center">
            <h3 class="text-black rfs:text-3xl mb-5">
              {{t('more-about-loan')}}
            </h3>
            <p class="text-gray-900">
              {{t('pre-filled-loan')}}
            </p>
          </div>
          <div class="flex lg:flex-row flex-col justify-between gap-12">
            <app-loan-calulator class="flex-1" [calcValues]="calcValues"></app-loan-calulator>
            <div class="max-w-[360px] w-full">
              <app-doughnut-chart [showEstimatedFees]="true"></app-doughnut-chart>
              <div class="mt-6 text-gray-700 font-semibold flex flex-row gap-2 text-xs justify-center"> 
                ΕΚΠΛΗΡΩΘΗΚΕ ΑΠΟ 
                <img src="assets/static/NBG-logo.png" alt="NBG Logo" />
              </div>
            </div>
          </div>
        </ng-container>
        }
        @case ('personalInfo') {
        <app-loan-eligibility-personal-info [form]="loanForm"></app-loan-eligibility-personal-info>
        }
        @case ('financialInfo') {
        <app-loan-eligibility-financial-info [form]="loanForm"></app-loan-eligibility-financial-info>
        }
        @case ('guarantor') {
        <app-loan-eligibility-guarantor [form]="loanForm"></app-loan-eligibility-guarantor>
        }
        }
      </ng-container>
    </div>
    <ng-container *ngIf="activeStep == 'loan'">
      <app-navigation-buttons [NextButtonEnabled]="loanForm.get(activeStep)?.valid ?? false" [HideSkip]="true"
        [HidePrevious]="true" (ExitButtonClicked)="openModalComponent()" (PreviousButtonClicked)="onPrevClick()"
        (NextButtonClicked)="onNextClick()" [CustomNextTitle]=""></app-navigation-buttons>
    </ng-container>
    <ng-container *ngIf="activeStep == 'personalInfo'">
      <app-navigation-buttons [NextButtonEnabled]="loanForm.get(activeStep)?.valid ?? false" [HideSkip]="true"
        [HidePrevious]="false" (ExitButtonClicked)="openModalComponent()" (PreviousButtonClicked)="onPrevClick()"
        (NextButtonClicked)="onNextClick()" [CustomNextTitle]=""></app-navigation-buttons>
    </ng-container>
    <ng-container *ngIf="activeStep == 'financialInfo'">
      <app-navigation-buttons [NextButtonEnabled]="loanForm.get(activeStep)?.valid ?? false" [HideSkip]="true"
        [HidePrevious]="false" (ExitButtonClicked)="openModalComponent()" (PreviousButtonClicked)="onPrevClick()"
        (NextButtonClicked)="onNextClick()" [CustomNextTitle]=""></app-navigation-buttons>
    </ng-container>
    <ng-container *ngIf="activeStep == 'guarantor'">
      <app-navigation-buttons [loading]="loading" [NextButtonEnabled]="loanForm.get(activeStep)?.valid ?? false" [HideSkip]="true"
        [HidePrevious]="false" (ExitButtonClicked)="openModalComponent()" (PreviousButtonClicked)="onPrevClick()"
        (NextButtonClicked)="onNextClick()" [CustomNextTitle]="t('getFullResultButton')"></app-navigation-buttons>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="showResultPage">
    <app-loan-eligibility-result [resultData]="loanResultData" [formData]="loanFormData" (resetForm)="onCloseResults()">
    </app-loan-eligibility-result>
  </ng-container>
</ng-container>
<!-- <input mask="separator.2" separatorLimit="10000000000000" [thousandSeparator]="thousandSeparator" /> -->
